<template>
  <div>
    <el-dialog
      :title="(item.ID ? '编辑' : '新增') + '用户'"
      :visible="visible"
      :close-on-click-modal="false"
      @close="onClose"
      @open="onOpen"
    >
      <el-form ref="itemform" :model="item" label-width="85px" :rules="rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :sl="12">
            <el-form-item label="姓名" prop="Name">
              <el-input
                v-model.trim="item.Name"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :sl="12">
            <el-form-item label="登录名" prop="Username">
              <el-input
                v-model.trim="item.Username"
                placeholder="请输入登录名"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :sl="12">
            <el-form-item label="手机号" prop="Phone">
              <el-input
                v-model.trim="item.Phone"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :sl="12">
            <el-form-item label="密码" prop="Password">
              <el-input
                v-if="!item.ID"
                v-model.trim="item.Password"
                type="password"
                placeholder="请输入密码"
              />
              <el-button v-else type="info" @click="resetPsw">
                初始化
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :sl="12">
            <el-form-item label="角色" prop="RoleIDs">
              <el-select
                v-model="item.RoleIDs"
                collapse-tags
                multiple
                placeholder="请选择角色"
                style="width: 100%"
              >
                <el-option
                  v-for="ele in roleList"
                  :key="ele.ID"
                  :label="ele.Name"
                  :value="ele.ID"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :sl="12">
            <el-form-item label="部门" prop="DepartmentIDs">
              <el-select
                v-model="item.DepartmentIDs"
                collapse-tags
                multiple
                placeholder="请选择部门"
                style="width: 100%"
              >
                <el-option
                  v-for="ele in deptList"
                  :key="ele.ID"
                  :label="ele.Name"
                  :value="ele.ID"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :sl="12">
            <el-form-item label="邮箱" prop="Email">
              <el-input
                v-model.trim="item.Email"
                placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="onClose">
          <i class="fas fa-fw fa-times" aria-hidden="true" />取 消
        </el-button>
        <el-button type="primary" :disabled="submitting" @click="onSubmit">
          <i class="far fa-fw fa-save" aria-hidden="true" />确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as _clone from 'lodash/clone';
// import FileUploader from '@/components/file-uploader.vue';

export default {
  // components: {
  //   FileUploader,
  // },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
    visible: {
      type: Boolean,
      default: false,
    },
    parkList: {
      type: Array,
      default: () => [],
    },
    corpList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const validePsw = (rule, value, callback) => {
      const test1 = /^\S{6,}$/;
      if (!this.item.ID && value === '') {
        callback(new Error('密码不能为空！'));
      } else if (!this.item.id && !test1.test(value)) {
        callback(new Error('密码至少为6位！'));
      } else {
        callback();
      }
    };
    const validateRole = (rule, value, callback) => {
      if (this.item.subject_type === 'saes' && value.length === 0) {
        callback(new Error('角色不能为空'));
      } else {
        callback();
      }
    };
    const validateDept = (rule, value, callback) => {
      if (this.item.subject_type === 'saes' && value.length === 0) {
        callback(new Error('部门不能为空'));
      } else {
        callback();
      }
    };
    return {
      item: {},
      subjectTypeIsEmpty: true,
      rules: {
        Name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { max: 50, message: '姓名不能超过50个字符', trigger: 'blur' },
        ],
        Username: [
          { required: true, message: '登录名不能为空', trigger: 'blur' },
          { max: 50, message: '登录名不能超过50个字符', trigger: 'blur' },
        ],
        // Password: [
        //   { required: true, message: '密码不能为空', trigger: 'blur' },
        // ],
        Phone: [
          { pattern: /^1[0-9]{10}$/, message: '手机号格式不正确', trigger: 'blur' },
        ],
        Email: [
          {
            pattern: /[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: '邮箱格式不正确',
            trigger: 'blur',
          },
        ],
        password: [{ validator: validePsw, trigger: 'blur' }],
        role_ids: [{ validator: validateRole }],
        department_ids: [{ validator: validateDept }],
      },
      submitting: false,
      roleList: [],
      deptList: [],
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
    };
  },
  created() {
    this.getRoleList();
    this.getDeptList();
  },
  methods: {
    onOpen() {
      this.item = _clone(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$nextTick(() => {
        this.$refs.itemform.clearValidate();
      });
      this.$refs.itemform.resetFields();
      // this.$refs.addFile.reset();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        this.$axios.request({
          url: this.item.ID ? `user/${this.item.ID}` : 'user',
          method: this.item.ID ? 'put' : 'post',
          data: this.item,
        }).then(() => {
          this.$message.success(this.item.ID ? '成功编辑用户' : '成功新增用户');
          this.submitting = false;
          this.$emit('form:saved', true);
          // this.$emit('update:visible', false);
          this.onClose();
        }).catch(({ response }) => {
          if (response.data && !response.data.message) {
            this.$message({
              message: response.data,
              type: response.status >= 500 ? 'error' : 'warning',
            });
          } else {
            this.$sys.alarmResponse(response);
          }
          this.submitting = false;
        });
      });
    },
    // 手动触发文件验证 添加公告
    onFileChange() {
      this.$refs.itemform.validateField('image');
    },
    // 重置密码
    resetPsw() {
      this.$confirm('确定要初始化密码吗？').then(
        () => this.$axios.put(`user/${this.item.ID}`, { password: 'init password' })
      ).then(() => {
        this.$message.success('成功初始化密码');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    getRoleList() {
      this.$axios.get('role', { params: {...this.pager,} }).then((response) => {
        this.roleList = response.data.data;
      }, ({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    getDeptList() {
      this.$axios.get('department', { params: { return_list: 1 } }).then((response) => {
        this.deptList = response.data.data;
      }, ({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
  },
};
</script>
